const doc = [({"da":({"js":({"admin":({"order_lines":({"expandable_content":({"orderables":({"photo_sheet_product_order_line":({"image":"Billede"})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;